import { Text, type TextProps } from "@repo/skapa";
import { useContext } from "react";

import { HeadingLevelContext } from "./HeadingLevelContext";

type HeadingProps = TextProps & { className?: string };

export const Heading = ({ children, ...props }: HeadingProps) => {
  const level = useContext(HeadingLevelContext);
  switch (level) {
    case 0:
      throw Error("Heading must be inside a HeadingSection!");
    case 1:
      return (
        <Text tagName="h1" {...props}>
          {children}
        </Text>
      );
    case 2:
      return (
        <Text tagName="h2" {...props}>
          {children}
        </Text>
      );
    case 3:
      return (
        <Text tagName="h3" {...props}>
          {children}
        </Text>
      );
    case 4:
      return (
        <Text tagName="h4" {...props}>
          {children}
        </Text>
      );
    case 5:
      return (
        <Text tagName="h5" {...props}>
          {children}
        </Text>
      );
    case 6:
      return (
        <Text tagName="h6" {...props}>
          {children}
        </Text>
      );
    default:
      return <Text {...props}>{children}</Text>;
  }
};
